export default function PHP_fflush() {
  return (
    <div>
      <h1>PHP_fflush</h1>
    </div>
  );
}
